import setupAccount from './account'
import setupBundleSelect from './bundle-select'
import setupDocument from './document'
import setupDragAndDrop from './drag-and-drop'
import setupLiveDocument from './live-document'
import setupRemoveButton from './remove-button'
import setupReportWidget from './report'
import setupSubmitButton from './submit-button'
import setupTextWidget from './text'
import setupToggleListButton from './toggle-list-button'
import setupCommunication from './communication'

export default function setupWidgets() {
  const unsubscribers = [
    setupAccount(),
    setupBundleSelect(),
    setupDocument(),
    setupDragAndDrop(),
    setupLiveDocument(),
    setupRemoveButton(),
    setupReportWidget(),
    setupSubmitButton(),
    setupTextWidget(),
    setupToggleListButton(),
    setupCommunication(),
  ]

  return () => unsubscribers.forEach((unsubscriber) => unsubscriber())
}
